import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject
} from '@angular/core';

@Component({
  selector: 'app-content-editor',
  templateUrl: './content-editor.component.html',
  styleUrls: ['./content-editor.component.scss'],
  standalone: false
})
export class ContentEditorComponent implements OnInit {
  private changeDetectorRef = inject(ChangeDetectorRef);

  @ViewChild('contentField') contentEl: ElementRef;

  initialContent: string;

  @Input()
  content: string;

  @Output()
  contentChange = new EventEmitter<string>();

  ngOnInit() {
    this.initialContent = this.content || '';
  }

  updateContent(html: string) {
    this.contentChange.emit(html);
  }

  onBold() {
    const selection = getSelection().toString();
    if (selection && this.contentEl.nativeElement.contains(getSelection().anchorNode)) {
      document.execCommand('bold');
    }
  }

  onItalic() {
    const selection = getSelection().toString();
    if (selection && this.contentEl.nativeElement.contains(getSelection().anchorNode)) {
      document.execCommand('italic');
    }
  }

  onUnderline() {
    const selection = getSelection().toString();
    if (selection && this.contentEl.nativeElement.contains(getSelection().anchorNode)) {
      document.execCommand('underline');
    }
  }

  isStyled() {
    return {
      bold: document.queryCommandState('bold'),
      italic: document.queryCommandState('italic'),
      underline: document.queryCommandState('underline')
    };
  }

  detectChanges() {
    this.changeDetectorRef.detectChanges();
  }

  clear() {
    this.initialContent = '';
    this.contentEl.nativeElement.innerHTML = '';
  }
}
